import React from "react";
import { Global, css } from "@emotion/react";
import { COLOURS } from "../styles/variables/Colors";

const GlobalStyles = () => (
  <Global
    styles={css`
      body,
      html {
        margin: 0;
        font-size: 16px;
      }

      .dg.ac {
        z-index: 999 !important;
      }

      canvas {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
      }

      #app {
        position: fixed;
      }

      #___gatsby {
        margin: 0;
        font-size: 18px;
        font-family: "univers-light", sans-serif;
        line-height: 1.4em;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow-x: hidden;
        color: rgba(33, 23, 3, 1);
        box-sizing: border-box;
        margin: 0;
      }

      a,
      a:visited {
        color: black;
        text-decoration: none;
      }

      button {
        padding: 0px;

        &:hover,
        &:focus {
          outline: none;
        }
      }

      img {
        max-width: 100%;
      }
    `}
  />
);

export default GlobalStyles;
